var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("width: 100%; text-align: " + (_vm.item.alignment))),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('img',{style:(("width:" + (_vm.item.width) + "px")),attrs:{"src":_vm.accountLogo}})])}
var staticRenderFns = []

export { render, staticRenderFns }